<template>
    <div>
        <!-- 短信修改密码的对话框 -->
          <el-dialog
          title="忘记密码"
          :visible.sync="messageModifyDialogVisible"
          width="50%"
          :close-on-click-modal="false"
          @close="messageModifyDialogClosed">
          <el-form :rules="messageModifyFormRules"
          ref="messageModifyFormRef" label-width="90px" :model="modifyForm">
              <el-form-item label="手机号" prop="phone" placeholder="请输入手机号">
                  <el-input v-model="modifyForm.phone"></el-input>
              </el-form-item>
              <el-form-item label="验证码"  prop="verificationCode">
                    <el-input  v-model="modifyForm.verificationCode" placeholder="请输入验证码">
                    <el-button slot="append" v-if="Verification" @click="getVerificationCode()">获取验证码</el-button>
                    <el-button slot="append" v-else-if="!Verification"><span>{{timer}}</span>秒后重新获取</el-button>
                    </el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPassword" placeholder="请输入新密码">
                  <el-input v-model="modifyForm.newPassword" show-password></el-input>
              </el-form-item>
              <el-form-item label="再次输入" prop="checkPassword">
                  <el-input v-model="modifyForm.checkPassword" show-password></el-input>
              </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
              <el-button @click="changeModifyDialog('1')">切换密码修改</el-button>
              <el-button @click="messageModifyDialogVisible=false">取 消</el-button>
              <el-button type="primary" @click="messageModifyPassword">确 定</el-button>
          </span>
          </el-dialog>
      <!-- 修改密码对话框 -->
      <el-dialog
        title="修改密码"
        :visible.sync="modifyDialogVisible"
        width="50%"
        :close-on-click-modal="false"
        @close="modifyDialogClosed">
        <el-form :rules="modifyFormRules"
        ref="modifyFormRef" label-width="90px" :model="modifyForm">
            <el-form-item label="原密码" prop="oldPassword">
                <el-input type="password" v-model="modifyForm.oldPassword" show-password></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
                <el-input type="password" v-model="modifyForm.newPassword" show-password></el-input>
            </el-form-item>
            <el-form-item label="再次输入" prop="checkPassword">
                  <el-input type="password" v-model="modifyForm.checkPassword" show-password ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="changeModifyDialog('0')">切换短信修改</el-button>
            <el-button @click="modifyDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="modifyPassword">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import * as api from '@/api/factory/central'
export default {
  props: {
  },
  data() {
    var checkOldPassword = (rule, value, cb) => {
      if (value === this.modifyForm.oldPassword) {
        return cb(new Error('新密码不能和旧密码一致'))
      }
      cb()
    }
    var passwordCheck = (rule, value, cb) => {
      if (value === this.modifyForm.newPassword) {
        return cb()
      }
      cb(new Error('输入的密码不一致'))
    }
    return {
      messageModifyDialogVisible: false,
      modifyDialogVisible: false,
      modifyForm: {
        phone: '',
        verificationCode: '',
        workerId: window.sessionStorage.getItem('id'),
        oldPassword: '',
        newPassword: '',
        username: '',
        checkPassword: ''
      },
      timer: 60, // 定义初始时间为60s
      autotimer: '',
      Verification: true,
      messageModifyFormRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: this.$valid.checkPhone, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 1, max: 15, message: '长度在6 到 15 个字符之间', trigger: 'blur' },
          { validator: checkOldPassword, trigger: 'blur' }
        ],
        checkPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { min: 1, max: 15, message: '长度在6 到 15 个字符之间', trigger: 'blur' },
          { validator: passwordCheck, trigger: 'blur' }
        ]
      },
      modifyFormRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 1, max: 15, message: '长度在6 到 15 个字符之间', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 1, max: 15, message: '长度在6 到 15 个字符之间', trigger: 'blur' },
          { validator: checkOldPassword, trigger: 'blur' }
        ],
        checkPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { min: 1, max: 15, message: '长度在6 到 15 个字符之间', trigger: 'blur' },
          { validator: passwordCheck, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 显示弹框，外部调用
    show() {
      this.modifyDialogVisible = true
    },
    // 隐藏,外部调用
    hide() {
      if (this.messageModifyDialogVisible) {
        this.messageModifyDialogVisible = false
      }
      if (this.modifyDialogVisible) {
        this.modifyDialogVisible = false
      }
    },
    // 短信修改密码
    messageModifyPassword() {
      this.modifyForm.username = JSON.parse(sessionStorage.getItem('userInfo')).username
      this.$refs.messageModifyFormRef.validate(valid => {
        if (!valid) return
        const data = {
            phone: this.modifyForm.phone,
            verificationCode: this.modifyForm.verificationCode,
            username: this.modifyForm.username,
            password: this.modifyForm.newPassword
          }
        api.messageModifyPassword(data).then(res => {
          this.messageModifyDialogVisible = false
          this.$message.success('修改密码成功！')
          this.$router.push('/login')
        })
      })
    },
    // 弹框关闭之后
    messageModifyDialogClosed() {
      clearInterval(this.autotimer)
      this.timer = 60
      this.Verification = true
      this.$refs.messageModifyFormRef.resetFields()
    },
    // 切换，因为有旧密码改新密码，还有验证码改新密码
    changeModifyDialog(from) {
      if (from === '1') {
        this.modifyDialogVisible = true
        this.messageModifyDialogVisible = false
      } else if (from === '0') {
        this.modifyDialogVisible = false
        this.messageModifyDialogVisible = true
      }
    },
    // 取消按钮
    modifyDialogClosed () {
      this.$refs.modifyFormRef.resetFields()
    },
    // 旧密码改新密码
    modifyPassword () {
      this.$refs.modifyFormRef.validate(async valid => {
        if (!valid) return
        const params = {
            newPassword: this.modifyForm.newPassword,
            oldPassword: this.modifyForm.oldPassword
          }
        api.modifyPassword(params).then(res => {
          this.modifyDialogVisible = false
          this.$message.success('修改密码成功！')
          this.$router.push('/login')
        })
      })
    },
    // 发送验证码
    sendVerificationCode (phone) {
      const params = { phone: phone }
      api.sendVerificationCode(params).then(res => {
        this.$message.success(`短信已发至手机${phone}！`)
      })
    },
    // 验证手机号，再调发送接口
    getVerificationCode (from) {
      if (this.validateAndtimer(this.modifyForm) === true) {
        this.sendVerificationCode(this.modifyForm.phone)
      }
    },
    // 验证手机号
    validateAndtimer(Form) {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (Form.phone === '') {
        this.$message.error('请输入手机号')
        return false
      }
      if (!regMobile.test(Form.phone)) {
        this.$message.error('手机号格式不正确，请重新输入')
        return false
      }
      this.Verification = false // 点击button改变v-show的状态
      this.autotimer = setInterval(() => { // 定时器设置每秒递减
        this.timer-- // 递减时间
        if (this.timer <= 0) {
          this.timer = 60
          this.Verification = true // 60s时间结束还原v-show状态并清除定时器
          clearInterval(this.autotimer)
        }
      }, 1000)
      return true
    }
  },
  created () {
    this.modifyForm.phone = JSON.parse(sessionStorage.getItem('userInfo')).phone
  }
}
</script>

<style scoped lang="scss">
</style>
